import useExchangeRate from './ggexchange'
import { useGetStakerCount } from './useStake'

// gets the liquid staking statistics from the contract
const useLiquidStakingData = () => {
  const { data: xGGPExchangeRate, isLoading: isExchangeRateLoading } = useExchangeRate()

  const { data: stakerCount } = useGetStakerCount()

  const isLoading = isExchangeRateLoading

  return {
    xGGPExchangeRate,
    isLoading,
    stakerCount,
  }
}

export default useLiquidStakingData
